import { useQuery } from "@tanstack/react-query";
import { getDetectByMonth } from "../api/detect";
import { DateFilter } from "../types/types";

interface PropsParams extends DateFilter {
  resetFetch: () => void;
  fetch: boolean;
  area: string;
  device_pid?: string;
  groupId?: string;
  mobility_code?: number;
}
const useGetDetectByMonth = ({
  startDate,
  endDate,
  area,
  device_pid,
  groupId,
  mobility_code,
}: PropsParams) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [
      "detect",
      `detectByMonth`,
      `startDate-${startDate}`,
      `endDate-${endDate}`,
      `area-${area}`,
      `groupId-${groupId}`,
      `mobility_code-${mobility_code}`,
    ],
    queryFn: () =>
      getDetectByMonth({
        startDate,
        endDate,
        area,
        device_pid,
        groupId,
        mobility_code,
      }),

    enabled: true,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 0,
  });

  return { data, isLoading, isSuccess };
};

export default useGetDetectByMonth;
